import * as ReactDOM from "react-dom";
import * as React from "react";

import "./main.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fad } from "@fortawesome/pro-duotone-svg-icons";

library.add(fad);

if (window.location.hash.includes("#redirect=")) {
    window.location = window.location.hash.replace("#redirect=", "");
}